import React from 'react'
import {renderToString} from 'react-dom/server'
import DOMPurify from 'dompurify'

let ControllerAlarm = ({children, value, dangerouslySetValue, valueClass, colorClass, dark, pulse}) =>
    <div className={"d-inline-block m-1 bg-dark rounded alarm-container " + (dark ? "text-dark " : "text-white ") + (pulse ? "pulse " : "")}>
        <div className={"d-inline-block pt-2 pb-2 pl-3 pr-3 " + colorClass} >
            {children}
        </div>
        {value ?
            <div className={"d-inline-block pt-2 pb-2 pl-3 pr-3 " + valueClass}>
                {value}
            </div>:
            (dangerouslySetValue ?
                <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(renderToString(dangerouslySetValue))}}></span>
                :null)}
    </div>

export default ControllerAlarm



// WEBPACK FOOTER //
// ./src/components/ui/ControllerAlarm.js